import Grid from "@components/Grid/Grid";
import Columns from "./Columns";

export interface Sublayout3070Props {
  content: {
    columns: Array<Record<string, unknown>>;
    backgroundColour?: string;
  };
}

const Sublayout3070 = (props: Sublayout3070Props["content"]) => {
  const { columns, backgroundColour } = props;

  return (
    <div
      className={`sublayout outer-wrap ${
        backgroundColour ? backgroundColour : ""
      }`}
    >
      <div className="wrapper">
        <Grid row>
          <Columns columns={columns} columnTotal={2} customSize={[4, 8]} />
        </Grid>
      </div>
    </div>
  );
};

export default Sublayout3070;
